<template>
  <v-layout fluid>
    <v-btn-toggle v-model="$i18n.locale" tile group dense mandatory>
      <v-btn @click="setLocale('lv')" value="lv" width="40">
        <country-flag country="lv" size="normal" />
      </v-btn>
      <v-btn @click="setLocale('ru')" value="ru" width="40">
        <country-flag country="ru" size="normal" />
      </v-btn>
      <v-btn @click="setLocale('en')" value="en" width="40">
        <country-flag country="gb" size="normal" />
      </v-btn>
    </v-btn-toggle>
  </v-layout>
</template>
<script>
import api from "@/api.js";
import CountryFlag from "vue-country-flag";

export default {
  components: { CountryFlag },
  props: ["value"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    setLocale(v) {
      api.setLocale(v);
    }
  }
};
</script>script


<style lang="scss" scoped>
</style>